'use strict';

import { Component } from 'react';
import moment from 'moment';

import { getAllPlanParticipants } from '@utils/Meals';

import './FamilyMembers.scss';

export default class FamilyMembers extends Component {
    renderFamilyMember = (member, i) => {
        const { preferences = {} } = this.props.profile;
        const age = member.birthdate ? moment().diff(member.birthdate, 'year') : null;

        return (
            <tr key={i}>
                <td className="person-info">
                    <em>{member.name}</em>
                    {age ? <span>, {age} year old</span> : null}
                    {member.gender ? <span>, {member.gender}</span>: null}
                    <span><br />Portion size: {member.portion}</span>
                </td>
                {preferences?.meal_types
                    ?.filter(p => p.main_dish != 'Snack')
                    .map(p => {
                        // Whether this participant is in the meal type comes from the meal
                        // type's own participant list ('USER' for the primary user, uuid for
                        // family) — the newly-added primary user and guests have no per-member
                        // `meal_types` field, so the old check always showed them as excluded
                        // (EAT-4028 review). Fall back to the per-member flags only if the
                        // participant list is absent. Guests aren't configured at the meal-type
                        // level, so they correctly render as not participating.
                        const inMealType = p.participants
                            ? p.participants.includes(member.uuid)
                            : member?.meal_types?.some(m => m.name == p.name && !!m.enabled);

                        return (
                            <td key={p.name}>
                                <i className={inMealType ? "icon-check2" : "icon-silverware2"} />
                            </td>
                        );
                    })}
            </tr>
        );
    }

    render = () => {
        const { profile, plan } = this.props;
        const { preferences = {} } = profile;
        const participants = getAllPlanParticipants(profile, plan);

        return (
            <div className="patient-family-members">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            {preferences?.meal_types
                                ?.filter(p => p.main_dish != 'Snack')
                                .map(p => (
                                    <th>{p.name}</th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>
                        {participants.map(this.renderFamilyMember)}
                    </tbody>
                </table>
            </div>
        );
    }
}
